import { render, staticRenderFns } from "./PermitHolderInformedConsent.vue?vue&type=template&id=1ebea1e6"
import script from "./PermitHolderInformedConsent.vue?vue&type=script&lang=js"
export * from "./PermitHolderInformedConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports